export enum ScheduledJobType {
    PublishSection = 'publish_section',
    CourseBooking = 'course_booking',
    SendSurveyReminder = 'send_survey_reminder',
    NotifyAll = 'send_notify_all',
    PasswordlessAcccess = 'send_pla',
}
